import HTTP from '@/plugins/http';

const userApi = {
  login: '/token/login',
  logout: '/token/logout'
};

function handleLogin(data) {
  return HTTP.loading({
    url: userApi.login,
    method: 'post',
    data
  });
}

function handleLogout() {
  return HTTP.loading({
    url: userApi.logout,
    method: 'post'
  });
}

export default { handleLogin, handleLogout };



// WEBPACK FOOTER //
// ./src/api/user.js